module.exports = {
	"controls": {
		"play": "Play",
		"pause": "Pause",
		"share": "Share",
		"language": "Language",
		"settings": "Settings",
		"fullscreen": "Fullscreen",
		"rewind": "Rewind",
		"vrStereo": "vrStereo",
		"live": "Live",
		"unmute": "Unmute",
		"next": "Next",
		"prev": "Prev",
		"startOver": "Start over",
		"pictureInPicture": "Picture in picture"
	},
	"unmute": {
		"unmute": "Unmute"
	},
	"copy": {
		"button": "Copy"
	},
	"settings": {
		"title": "Settings",
		"quality": "Quality",
		"speed": "Speed"
	},
	"language": {
		"title": "Language",
		"audio": "Audio",
		"captions": "Captions",
		"advanced_captions_settings": "Advanced captions settings"
	},
	"share": {
		"title": "Share",
		"embed_options": "Embed Options",
		"start_video_at": "Start video at",
		"email": "Share on Email",
		"embed": "Get embed code"
	},
	"overlay": {
		"close": "Close"
	},
	"error": {
		"default_error": "Something went wrong",
		"default_session_text": "Session ID",
		"retry": "Retry"
	},
	"ads": {
		"ad_notice": "Advertisement",
		"learn_more": "Learn more",
		"skip_ad": "Skip ad",
		"skip_in": "Skip in"
	},
	"cvaa": {
		"title": "Advanced captions settings",
		"sample_caption_tag": "Sample",
		"set_custom_caption": "Set custom caption",
		"edit_caption": "Edit caption",
		"size_label": "Size",
		"font_color_label": "Font color",
		"font_family_label": "Font family",
		"font_style_label": "Font style",
		"font_opacity_label": "Font opacity",
		"background_color_label": "Background color",
		"background_opacity_label": "Background opacity",
		"apply": "Apply",
		"caption_preview": "This is your caption preview"
	},
	"cast": {
		"play_on_tv": "Play on TV",
		"disconnect_from_tv": "Disconnect from TV",
		"status": {
			"connecting_to": "Connecting to",
			"connected_to": "Connected to",
			"playing_on": "Playing on"
		}
	},
	"playlist": {
		"prev": "Previous",
		"next": "Next",
		"up_next": "Up Next",
		"cancel": "Cancel"
	},
	"pictureInPicture": {
		"overlay_text": "Playing in Picture In Picture mode",
		"overlay_button": "Play Here"
	}
};


//////////////////
// WEBPACK FOOTER
// ./translations/en.json
// module id = 109
// module chunks = 0


// WEBPACK FOOTER //
// ui/translations/en.json